<template>
    <cic-popup
        :title="item.notificationId ? 'Edit Email Notification' : 'New Email Notification'"
        :editable="
            item.notificationId > 0 &&
            item.orgId === $store.user.orgId &&
            $store.hasRight('EDIT_TRANSMIT_NOTIFICATIONS')
        "
        :saveable="
            item.notificationId <= 0 ||
            (item.orgId === $store.user.orgId && $store.hasRight('EDIT_TRANSMIT_NOTIFICATIONS'))
        "
        @blur="$emit('blur')"
        @edit="toggleEdit"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="notification_name"
                        :value="item.name"
                        :enabled="editing"
                        :maxlength="50"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Share To Child Organisations') }}
                </li>
                <li>
                    <cic-checkbox
                        id="notification_share"
                        :value="item.share"
                        :enabled="editing"
                        @input="(val) => updateFieldValue('share', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('From Address') }}
                </li>
                <li>
                    <cic-textbox
                        id="notification_from"
                        :value="item.fromAddress"
                        :enabled="editing"
                        :maxlength="512"
                        @input="(val) => updateFieldValue('fromAddress', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('To Addresses') }}
                </li>
                <li>
                    <cic-select
                        id="notification_to"
                        :value="item.toAddresses"
                        :enabled="editing"
                        :multiple="true"
                        :allow-create="true"
                        :filterable="true"
                        :options="
                            item.toAddresses.map((x) => {
                                return { value: x, label: x };
                            })
                        "
                        popper-class="to-popper"
                        @input="(val) => updateFieldValue('toAddresses', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('CC Addresses') }}
                </li>
                <li>
                    <cic-select
                        id="notification_cc"
                        :value="item.ccAddresses"
                        :enabled="editing"
                        :multiple="true"
                        :allow-create="true"
                        :filterable="true"
                        :options="
                            item.ccAddresses.map((x) => {
                                return { value: x, label: x };
                            })
                        "
                        @input="(val) => updateFieldValue('ccAddresses', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('BCC Addresses') }}
                </li>
                <li>
                    <cic-select
                        id="notification_bcc"
                        :value="item.bccAddresses"
                        :enabled="editing"
                        :multiple="true"
                        :allow-create="true"
                        :filterable="true"
                        :options="
                            item.bccAddresses.map((x) => {
                                return { value: x, label: x };
                            })
                        "
                        @input="(val) => updateFieldValue('bccAddresses', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Success Template') }}
                </li>
                <li>
                    <cic-select
                        id="notification_success"
                        :value="item.parameters.SuccessTemplateID"
                        :enabled="editing"
                        :options="
                            templates.map((x) => {
                                return { value: x.templateId, label: x.name };
                            })
                        "
                        popper-class="success-popper"
                        @input="(val) => updateFieldValue('SuccessTemplateID', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Failure Template') }}
                </li>
                <li>
                    <cic-select
                        id="notification_failure"
                        :value="item.parameters.FailureTemplateID"
                        :enabled="editing"
                        :options="
                            templates.map((x) => {
                                return { value: x.templateId, label: x.name };
                            })
                        "
                        popper-class="failure-popper"
                        @input="(val) => updateFieldValue('FailureTemplateID', val)"
                    />
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditTransmitNotification',
        components: {
            CicCheckbox,
            CicPopup,
            CicSelect,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            templates: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'input', 'updateFieldValue'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = this.item.notificationId <= 0;
        },
        methods: {
            toggleEdit() {
                this.editing = !this.editing;
            },

            updateFieldValue(field, value) {
                this.$emit('updateFieldValue', field, value);
            },
        },
    };
</script>
